var render = function render(){var _vm=this,_c=_vm._self._c;return _c('tfoot',[_c('tr',[_c('th',[_vm._v("Total Cuota Bruta")]),_vm._l((_vm.entries),function(entry,idx){return _c('th',{key:idx,staticClass:"text-no-wrap"},[_vm._v(_vm._s(_vm.parseValue(entry.value)))])})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }